import { styled, Button, Box, Typography } from '../../base';

export const ContentWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    color: theme.palette.text.secondary,
}));

export const TruncatedTypography = styled(Typography)({
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

export const ReadMoreButton = styled(Button)(({ theme }) => ({
    textDecoration: 'underline',
    whiteSpace: 'nowrap',
    minWidth: 'auto',
    padding: 0,
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
}));
